import { render, staticRenderFns } from "./MovementsList.vue?vue&type=template&id=4869ea4e"
import script from "./MovementsList.vue?vue&type=script&lang=js"
export * from "./MovementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports